import React, { useEffect } from 'react';
import { useThemeStore } from '../utils/themeManager';

export const ThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const theme = useThemeStore((state) => state.theme);

  useEffect(() => {
    let style = document.getElementById('style-app') as HTMLStyleElement | null;
    if (!style) {
      style = document.createElement('style');
      style.id = 'style-app';
      document.head.appendChild(style);
    }
    style.innerHTML = `
      :root {
        --primary-color: ${theme.primaryColor};
        --secondary-color: ${theme.secondaryColor};
      }

      .bg-primary, .bg-primary-500 { background-color: ${theme.primaryColor} !important; }
      .text-primary, .text-primary-500 { color: ${theme.primaryColor} !important; }
      .border-primary, .border-primary-500 { border-color: ${theme.primaryColor} !important; }
      .text-secondary, .text-secondary-500 { color: ${theme.secondaryColor} !important; }
      .border-secondary, .border-secondary-500 { border-color: ${theme.secondaryColor} !important; }
    `;
  }, [theme.primaryColor, theme.secondaryColor]);

  return <>{children}</>;
};

export default ThemeProvider;
